import sha256 from "crypto-js/sha256";
import hmacSHA256 from "crypto-js/hmac-sha256";
import Base64 from "crypto-js/enc-hex";
import Hex from "crypto-js/enc-hex";

function getXAppNonce(timestamp: number) {
  const radom = Math.random();
  const nonce = Base64.stringify(sha256((timestamp + radom).toString()));
  return nonce;
}

function getXAppSignature(
  signkey: string,
  timestamp: number,
  nonce: string,
  body: DynamicObject
) {
  const conBody = Object.assign(body, { nonce: nonce, timestamp: timestamp });
  const sortBody = sortObject(conBody);
  const paramsArray = [];

  for (const key in sortBody) {
    const value = sortBody[key];
    if (value instanceof Array || (typeof value == "object" && value != null)) {
      paramsArray.push(key + "=");
    } else if (
      typeof value != "object" &&
      !Number.isNaN(value) &&
      typeof value != "undefined"
    ) {
      paramsArray.push(key + "=" + value);
    }
  }
  const paramsStr = paramsArray.join("&");
  const signature = Hex.stringify(hmacSHA256(paramsStr, signkey)).toUpperCase();
  return signature;
}

function sortObject(bodyObj: DynamicObject) {
  const orderBody: DynamicObject = {};

  Object.keys(bodyObj)
    .sort()
    .forEach(function (key) {
      orderBody[key] = bodyObj[key];
    });

  return orderBody;
}

export { getXAppSignature, sortObject, getXAppNonce };
